const Pages = {
    ProductNotCarried: '/search?keyword=productnotcarried',
    Error404: '/error/404',
    BrandsList: '/brands-list',
    BeautyInsider: '/profile/BeautyInsider'
};

export { Pages };
